<template>
  <question-base-wrapper
    title="What sort of property is it?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed }"
      name="Property Sort"
      :vid="`${stepId}_property-sort`"
      rules="required"
      slim
    >
      <radio
        v-model="questionData.propertySort"
        name="property-sort"
        column
        wide
        :error="failed"
        :items="propertySortItems"
        :data-test="snakeCase(questionFields.propertySort)"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import IconTypeHouse from '!svg-inline-loader!@/assets/icons/icon-type-house.svg';
import IconTypeApartment from '!svg-inline-loader!@/assets/icons/icon-type-apartment.svg';
import IconTypeBungalow from '!svg-inline-loader!@/assets/icons/icon-type-bungalow.svg';
import IconTypeTownHouse from '!svg-inline-loader!@/assets/icons/icon-type-town-house.svg';
import IconTypeOther from '!svg-inline-loader!@/assets/icons/icon-type-other.svg';

export default {
  name: 'question-property-sort',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertySort'],
    };
  },
  computed: {
    propertySortItems () {
      const options = this.helpers.createOptions({ source: this.constants.HOME_PROPERTY_SORT });

      options.forEach(option => {
        if (option.value === 'H') {
          option.icon = IconTypeHouse;
          option.iconType = 'component';
        }
        if (option.value === 'A') {
          option.icon = IconTypeApartment;
          option.iconType = 'component';
        }
        if (option.value === 'B') {
          option.icon = IconTypeBungalow;
          option.iconType = 'component';
        }
        if (option.value === 'T') {
          option.icon = IconTypeTownHouse;
          option.iconType = 'component';
        }
        if (option.value === 'O') {
          option.icon = IconTypeOther;
          option.iconType = 'component';
        }
      });

      return options;
    },
  },
};
</script>
